import { useUser } from "@/context/useUser";
import navigationRoutes from "@/utils/navigationRoutes";
import { Spin } from "antd";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouter = () => {
  const { isAuthenticated, isBootstrapping } = useUser();

  if (isBootstrapping) {
    return <Spin fullscreen />;
  }

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={navigationRoutes.LOGIN} />
  );
};

export default ProtectedRouter;
